import styled from '@emotion/styled';
import { colors, spacing, typography } from '../../../../../../../themes';
import { hoverCheckboxStyle } from '../../../../styles';

export const GroupedListWrapper = styled.div<{ nestedIndex: number; disabled?: boolean }>`
  display: flex;
  flex-flow: row;
  align-items: center;

  gap: ${spacing.xsmall};
  padding: ${spacing.xmsmall};
  ${({ nestedIndex }) => nestedIndex > 0 && `padding-left: ${12 + nestedIndex * 12}px;`}

  ${({ disabled }) =>
    disabled
      ? `
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  `
      : `
    &:hover {
      background-color: ${colors.background.grey};
      cursor: pointer;
    }
  `}

  ${hoverCheckboxStyle}
`;

export const GroupedListContent = styled.div`
  display: flex;
  flex-flow: column;
`;

export const ChevronWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  margin-left: auto;
`;

export const Label = styled.div<{ showBold: boolean }>`
  ${typography.body.large};
  ${({ showBold }) => showBold && typography.body.largeBold};
`;

export const Divider = styled.hr`
  border: 0;
  height: 1px;
  background-color: ${colors.monochrome.grey20};
  margin: 0;
`;

export const GroupLabel = styled.div`
  ${typography.body.largeBold};
  padding-top: ${spacing.xsmall};
  padding-bottom: ${spacing.tiny};
  padding-left: ${spacing.xsmall};
  padding-right: ${spacing.xsmall};
`;

export const Badge = styled.span<{ variant: 'success' | 'error' | 'neutral' }>`
  ${typography.body.small};
  display: inline-flex;
  align-items: center;
  padding: 2px ${spacing.xsmall};
  border-radius: 4px;
  margin-left: ${spacing.xsmall};
  border: 1px solid;

  ${({ variant }) => {
    switch (variant) {
      case 'success':
        return `
          background-color: ${colors.alerts.successTint3};
          color: ${colors.alerts.successShade2};
          border-color: ${colors.alerts.successTint1};
        `;
      case 'error':
        return `
          background-color: ${colors.alerts.errorTint3};
          color: ${colors.alerts.errorShade2};
          border-color: ${colors.alerts.errorTint1};
        `;
      case 'neutral':
      default:
        return `
          background-color: ${colors.monochrome.grey20};
          color: ${colors.monochrome.grey70};
          border-color: ${colors.monochrome.grey40};
        `;
    }
  }}
`;
